import HTTP from '@rocketfid/api'

const state = {
  items: [],
  total: 0,
  type: 'basic',
  bubble: null
}

// getters
const getters = {
  customers: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getTotal: (state) => {
    return state.total
  }
}

// actions
const actions = {
  loadCustomersPage ({ commit, dispatch, rootGetters }, { page }) {
    let sitekey = rootGetters['account/currentSitekey']
    commit('RESET_CUSTOMER_ITEMS')

    if (state.type === 'bubble') {
      return HTTP
        .axios.get(process.env.API + '/bubble/' + state.bubble.id + '/users/' + page + '/24/')
        .then((results) => {
          commit('UPDATE_TYPE', { type: 'bubble' })
          commit('ADD_CUSTOMER_ITEMS', { items: results.data })
          commit('ADD_CUSTOMER_TOTAL', { total: results.headers['x-total'] })
          return results
        })
    }

    return HTTP
      .setInstance(sitekey)
      .customer.getByPage(page)
      .then((customers) => {
        commit('ADD_CUSTOMER_ITEMS', { items: customers })
        commit('ADD_CUSTOMER_TOTAL', { total: HTTP.customer.getTotal() })
        return customers
      })
  },

  loadCustomerById ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .customer.get(id)
      .then((customer) => {
        commit('ADD_CUSTOMER_ITEM', { items: customer })
        return customer
      })
  },

  filterByBubbles ({ commit, dispatch, rootGetters }, { bubbles }) {
    let sitekey = rootGetters['account/currentSitekey']
    dispatch('customers/resetCustomers', null, { root: true })
    commit('ADD_CUSTOMER_TOTAL', { total: 0 })

    if (bubbles.length === 0) {
      commit('UPDATE_TYPE', { type: 'basic' })
      commit('UPDATE_BUBBLE', { bubble: null })
      return dispatch('customers/loadCustomersPage', {page: 0}, { root: true })
    } else if (bubbles.length === 1) {
      commit('RESET_CUSTOMER_ITEMS')
      return HTTP
        .axios.get(process.env.API + '/bubble/' + bubbles[0].id + '/users/0/24/')
        .then((results) => {
          commit('UPDATE_TYPE', { type: 'bubble' })
          commit('UPDATE_BUBBLE', { bubble: bubbles[0] })
          commit('ADD_CUSTOMER_ITEMS', { items: results.data })
          commit('ADD_CUSTOMER_TOTAL', { total: results.headers['x-total'] })
          return results
        })
    } else {
      commit('UPDATE_TYPE', { type: 'bubbles' })
      commit('UPDATE_BUBBLE', { bubble: null })
      return HTTP
        .setInstance(sitekey)
        .bubble.getIntersections(bubbles)
        .then((results) => {
          results.forEach((result) => {
            if (bubbles.length === result.bubbles.length) {
              result.users.forEach((user) => {
                setTimeout(() => {
                  HTTP.customer.get(user['$id']).then((customer) => {
                    commit('ADD_CUSTOMER_ITEM', { items: customer })
                  })
                }, Math.floor(Math.random() * (400 - 100 + 1)) + 100)
              })
              commit('ADD_CUSTOMER_TOTAL', { total: result.users.length })
            }
          })
          return results
        })
    }
  },

  resetCustomers ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_CUSTOMER_ITEMS')
      resolve()
    })
  },

  removeCustomer ({ commit, rootGetters }, { customer }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .customer.delete(customer)
      .then(() => {
        commit('REMOVE_CUSTOMER_ITEM', { item: customer })
      })
  }
}

// mutations
const mutations = {
  UPDATE_BUBBLE: (state, { bubble }) => {
    state.bubble = bubble
  },
  UPDATE_TYPE: (state, { type }) => {
    state.type = type
  },
  ADD_CUSTOMER_ITEM: (state, { items }) => {
    state.items.push(items)
  },
  ADD_CUSTOMER_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },
  ADD_CUSTOMER_TOTAL: (state, { total }) => {
    state.total = total
  },
  RESET_CUSTOMER_ITEMS: (state) => {
    state.items = []
  },

  REMOVE_CUSTOMER_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customers.js